import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { ClientService } from '@core/client/config.service';
import { atsNavigation, ChildNavigation } from '@core/interfaces/navigation.interfaces';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';

@Injectable({ providedIn: 'root' })
export class NavigatonService {

    private _menuOptions: ChildNavigation[] = [];
    private _menuOptions$ = new BehaviorSubject<ChildNavigation[]>(this._menuOptions);
    menuOptions$ = this._menuOptions$.asObservable();

    private _menuOptionsPrimary: ChildNavigation[];

    public currentView$ = new BehaviorSubject<string>('');

    constructor(
        public toastService: ToastService,
        private _authStorageService: AuthenticationStorageService,
        public clientService: ClientService) {
    }

    getRootNavigation() {
        return atsNavigation.filter(navItem => this._authStorageService.hasAnyPermission(navItem.permissions, navItem.negativePermissions) && navItem.visible !== false);
    }

    setSubNav(root: string) {
        let subNav = atsNavigation.find(p => p.name === root).children;
        subNav = subNav.filter(navItem => this._authStorageService.hasAnyPermission(navItem.permissions));
        this._menuOptionsPrimary = subNav;
        this._menuOptions$.next(subNav);
    }

    setSubNavByUrl(url: string) {
        const subNav = atsNavigation.find(p => p.url === url);
        if (!!subNav) {
            this._menuOptionsPrimary = subNav.children.filter(navItem => this._authStorageService.hasAnyPermission(navItem.permissions));
            this._menuOptions$.next(this._menuOptionsPrimary);
        } else {
            this._menuOptionsPrimary = [];
            this._menuOptions$.next([]);
        }
    }

    setViewSubNav(root: string) {
        if (root !== 'Manage') {
            const subNav = atsNavigation.find(p => p.name === root).children;
            this._menuOptions$.next(subNav);
        }
    }

    clearViewSubNav() {
        this._menuOptions$.next(this._menuOptionsPrimary);
    }
}
